module.exports = __webpack_public_path__ + "static/media/create-case.3909532d.svg";